import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { VisitDetailPhotos } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { Observable } from 'rxjs';

export class AdditionalIDPhotosEndpoints {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  post(visitId: number, payload: VisitDetailPhotos.ReviewPayload) {
    return this.http.post(`${this.env.constants.ADMIN_API_URL}/admin/orders/${visitId}/additional/idphotos`, payload);
  }

  get(visitId: number): Observable<VisitDetailPhotos.AdditionalIdResponse> {
    return this.http.get<VisitDetailPhotos.AdditionalIdResponse>(
      `${this.env.constants.ADMIN_API_URL}/admin/orders/${visitId}/additional/idphotos`,
    );
  }
}
